var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drip-container"},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height}}),_vm._v(" "),_c('h1',{staticClass:"masked-text"},[_vm._v("dripping with talent")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-002b6c54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CanvasDrip.vue
// module id = null
// module chunks = 